import { render, staticRenderFns } from "./ProduzioneLayoutEcogreenAdapter.vue?vue&type=template&id=74e14162&scoped=true&"
import script from "./ProduzioneLayoutEcogreenAdapter.vue?vue&type=script&lang=js&"
export * from "./ProduzioneLayoutEcogreenAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e14162",
  null
  
)

export default component.exports